<template>
  <div class="header-container" :class="{ distributionFlag }">
    <div class="user">
      <div class="user-info">
        <div
          class="avatar"
          :style="{ backgroundImage: 'url(' + avatar_c + ')' }"
        ></div>
        <div class="name-account">
          <div class="name">
            <span>{{ userInfoNickname || "品牌折扣店" }}</span>
          </div>
          <div class="account">{{ userInfoAccount }}</div>
        </div>
      </div>
      <!-- <div class="border border-white rounded-full text-xs py-1 px-5">编辑</div> -->
    </div>
    <div class="statistics"></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters(["distributionFlag"]),
    ...mapState({
      userInfoNickname: (state) => state.user.userInfoNickname,
      userInfoAvatar: (state) => state.user.userInfoAvatar,
      userInfoAccount: (state) => state.user.userInfoAccount,
    }),
    avatar_c() {
      return this.userInfoAvatar || require("@/assets/setting/avatar.png");
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  color: #fff;
  padding-top: 16px;
  background: #c82d26;
  text-align: left;
  .user {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .user-info {
    display: flex;
    .avatar {
      width: 120px;
      height: 120px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      border-radius: 100%;
    }
    .name-account {
      padding-top: 18px;
      padding-left: 20px;
      .name {
        display: flex;
        align-items: center;
        font-size: 36px;
        line-height: 50px;
        font-weight: 600;
        .level {
          background: #fff;
          font-size: 20px;
          line-height: 1em;
          margin-left: 12px;
          border-radius: 8px;
          font-weight: normal;
          i {
            display: inline-block;
            font-style: normal;
          }
          .level-pre {
            color: #333;
            background: linear-gradient(135deg, #ffbd00 0%, #ff6e00 100%);
            border-radius: 8px 20px 0px 8px;
            padding: 8px 14px;
          }
          .level-val {
            padding: 8px 18px;
          }
        }
      }
      .account {
        font-size: 24px;
        line-height: 34px;
      }
    }
  }

  .statistics {
    position: relative;
    display: flex;
    text-align: center;
    padding-top: 20px;
    &::after {
      position: absolute;
      content: "";
      height: 200px;
      bottom: -90px;
      left: 0;
      right: 0;
      border-radius: 90px / 90px;
      background: #c82d26;
      z-index: -1;
    }
    .item {
      flex: 4;
      .num {
        font-size: 40px;
        font-weight: 800;
        line-height: 54px;
      }
      .tit {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
      }
    }
  }
}
</style>